import { React, useEffect, useMemo, useRef, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import {
    Box, Switch, CircularProgress, Backdrop, TextField, Button, FormControl, Select,
    Dialog, DialogActions, DialogContent, DialogContentText, List, ListItem, Typography,
    InputLabel, ListItemText, Checkbox, OutlinedInput, MenuItem, Autocomplete, Chip
} from '@mui/material';
import {
    DataGridPro,
    GridToolbar
} from '@mui/x-data-grid-pro';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { toast } from 'react-toastify';
import axios from 'axios';

import { socket } from './socket';

var api = axios.create({ withCredentials: true });

// A user with no dashboards only gets the map (reports.issimro.com/map), scoped to their territory.
const MAPS_ONLY = 'Maps only';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP
        },
    },
};

function Users(props) {
    const { getAccessTokenSilently } = useAuth0();
    const [rows, setRows] = useState(null);
    const [dashboards, setDashboards] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [warehouses, setWarehouses] = useState([]);
    const [salesmen, setSalesmen] = useState([]);
    const [lookupsReady, setLookupsReady] = useState(false);   // first load of all four lookup lists succeeded
    const [lookupsError, setLookupsError] = useState(false);   // ...or at least one of them failed
    const usersSeq = useRef(0);                                  // only the newest /api/users/all response applies
    const user = props.user;
    const isConnected = props.isConnected;
    const [openAdd, setAddOpen] = useState(false);
    const [addEmail, setAddEmail] = useState(null);
    const [addFname, setAddFname] = useState(null);
    const [addLname, setAddLname] = useState(null);
    const [adddashboards, setAddDashboards] = useState([]);
    const [adddashtext, setAddDashText] = useState([]);
    const [adddistricts, setAddDistricts] = useState([]);
    const [adddistrictstext, setAddDistrictsText] = useState([]);
    const [addwarehouses, setAddWarehouses] = useState([]);
    const [addwarehousestext, setAddWarehousesText] = useState([]);
    const [addsalesmen, setAddSalesmen] = useState([]);
    const [addsalesmentext, setAddSalesmenText] = useState([]);
    const [addAdmin, setAddAdmin] = useState(false);
    const [openDelete, setDeleteOpen] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [deleteAuth, setDeleteAuth] = useState(null);

    const handleAddClickOpen = () => {
        setAddOpen(true);
    };
    const handleAddClose = () => {
        setAddEmail(null);
        setAddFname(null);
        setAddLname(null);
        setAddAdmin(false);
        setAddDashboards([]);
        setAddDashText([]);
        setAddDistricts([]);
        setAddDistrictsText([]);
        setAddWarehouses([]);
        setAddWarehousesText([]);
        setAddSalesmen([]);
        setAddSalesmenText([]);
        setAddOpen(false);
    };

    function updateAddDashboards(value) {
        var adv = adddashboards;
        var adt = adddashtext;
        var f = false;
        adv.forEach((v) => {
            if (v === value) {
                f = true;
            }
        });
        if (f) {
            dashboards.forEach((db) => {
                if (db.value === value) {
                    adv = adv.filter((x) => {
                        return x !== value;
                    });
                    adt = adt.filter((x) => {
                        return x !== db.text;
                    });
                }
            });
        } else {
            adv.push(value);
            dashboards.forEach((db) => {
                if (db.value === value) {
                    adt.push(db.text);
                }
            });
        }

        setAddDashboards([...adv]);
        setAddDashText([...adt]);
    }

    function updateAddDistricts(value) {
        var adv = adddistricts;
        var adt = adddistrictstext;
        var f = false;
        adv.forEach((v) => {
            if (v === value) {
                f = true;
            }
        });
        if (f) {
            districts.forEach((db) => {
                if (db.value === value) {
                    adv = adv.filter((x) => {
                        return x !== value;
                    });
                    adt = adt.filter((x) => {
                        return x !== db.text;
                    });
                }
            });
        } else {
            adv.push(value);
            districts.forEach((db) => {
                if (db.value === value) {
                    adt.push(db.text);
                }
            });
        }

        if (value === 'All Districts') {
            adv = [];
            adt = [];
        }

        setAddDistricts([...adv]);
        setAddDistrictsText([...adt]);
    }

    function updateAddWarehouses(value) {
        var adv = addwarehouses;
        var adt = addwarehousestext;
        var f = false;
        adv.forEach((v) => {
            if (v === value) {
                f = true;
            }
        });
        if (f) {
            warehouses.forEach((db) => {
                if (db.value === value) {
                    adv = adv.filter((x) => {
                        return x !== value;
                    });
                    adt = adt.filter((x) => {
                        return x !== db.text;
                    });
                }
            });
        } else {
            adv.push(value);
            warehouses.forEach((db) => {
                if (db.value === value) {
                    adt.push(db.text);
                }
            });
        }

        if (value === 'All Warehouses') {
            adv = [];
            adt = [];
        }

        setAddWarehouses([...adv]);
        setAddWarehousesText([...adt]);
    }

    function updateAddSalesmen(value) {
        var adv = addsalesmen;
        var adt = addsalesmentext;
        var f = false;
        adv.forEach((v) => {
            if (v === value) {
                f = true;
            }
        });
        if (f) {
            salesmen.forEach((db) => {
                if (db.value === value) {
                    adv = adv.filter((x) => {
                        return x !== value;
                    });
                    adt = adt.filter((x) => {
                        return x !== db.text;
                    });
                }
            });
        } else {
            adv.push(value);
            salesmen.forEach((db) => {
                if (db.value === value) {
                    adt.push(db.text);
                }
            });
        }

        if (value === 'All Salesmen') {
            adv = [];
            adt = [];
        }

        setAddSalesmen([...adv]);
        setAddSalesmenText([...adt]);
    }

    function getDashboards() {
        return getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            return api.get(`${process.env.REACT_APP_BASEURL}/api/dashboards/all`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
                var dashboards = [];
                response.data.forEach((dashboard) => {
                    dashboards.push({ key: dashboard._id, value: dashboard._id, text: dashboard.dashboard });
                });
                setDashboards(dashboards);
                return true;
            }).catch((cerror) => {
                console.log(cerror.response ? cerror.response.data : cerror);
                return false;
            });
        }).catch((token_error) => {
            console.log(token_error);
            return false;
        });
    }

    function getDistricts() {
        return getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            return api.get(`${process.env.REACT_APP_BASEURL}/api/dashboards/districts`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
                var districts = [];
                response.data.forEach((s) => {
                    districts.push({ key: s._id, value: s._id, text: s.district });
                });
                setDistricts(districts);
                return true;
            }).catch((cerror) => {
                console.log(cerror.response ? cerror.response.data : cerror);
                return false;
            });
        }).catch((token_error) => {
            console.log(token_error);
            return false;
        });
    }

    function getWarehouses() {
        return getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            return api.get(`${process.env.REACT_APP_BASEURL}/api/dashboards/warehouses`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
                var warehouses = [];
                response.data.forEach((s) => {
                    warehouses.push({ key: s._id, value: s._id, text: s.warehouse });
                });
                setWarehouses(warehouses);
                return true;
            }).catch((cerror) => {
                console.log(cerror.response ? cerror.response.data : cerror);
                return false;
            });
        }).catch((token_error) => {
            console.log(token_error);
            return false;
        });
    }

    function getSalesmen() {
        return getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            return api.get(`${process.env.REACT_APP_BASEURL}/api/dashboards/salesmen`, { headers: { Authorization: `Bearer ${token}` } }).then(response => {
                var salesmen = [];
                response.data.forEach((s) => {
                    salesmen.push({ key: s._id, value: s._id, text: s.salesman_name });
                });
                setSalesmen(salesmen);
                return true;
            }).catch((cerror) => {
                console.log(cerror.response ? cerror.response.data : cerror);
                return false;
            });
        }).catch((token_error) => {
            console.log(token_error);
            return false;
        });
    }

    function addNewUser() {
        if (
            addEmail !== null
            && addFname !== null
            && addLname !== null
            && addAdmin !== null
        ) {
            getAccessTokenSilently({
                audience: process.env.REACT_APP_AUTH0AUDIENCE,
                scope: process.env.REACT_APP_AUTH0SCOPE
            }).then((token) => {
                api.post(`${process.env.REACT_APP_BASEURL}/api/users/adduser`,
                    {
                        email: addEmail,
                        fname: addFname,
                        lname: addLname,
                        admin: addAdmin,
                        dashboards: adddashboards,
                        districts: adddistricts,
                        warehouses: addwarehouses,
                        salesmen: addsalesmen
                    },
                    {
                        headers: { Authorization: `Bearer ${token}` }
                    }
                ).then((response) => {
                    setAddOpen(false);
                    toast.success(`User Added.`);
                }).catch((err) => {
                    if (err.message !== 'canceled') {
                        setAddOpen(false);
                        toast.error(err.response.data);
                    }
                });
            });
        } else {
            toast.error('All Fields are Required.');
        }
    }

    const handleDeleteClickOpen = () => {
        setDeleteOpen(true);
    };
    const handleDeleteClose = () => {
        setDeleteOpen(false);
    };

    function deleteUser(id, auth0) {
        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.get(`${process.env.REACT_APP_BASEURL}/api/users/delete/${id}/${auth0}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            ).then((response) => {
                setDeleteId(null);
                setDeleteAuth(null);
                setDeleteOpen(false);
                toast.success(`User Deleted.`);
            }).catch((err) => {
                if (err.message !== 'canceled') {
                    setDeleteId(null);
                    setDeleteAuth(null);
                    setDeleteOpen(false);
                    toast.error(err.response.data);
                }
            });
        });
    }

    function toggleAdmin(id, admin, email) {
        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.get(`${process.env.REACT_APP_BASEURL}/api/users/admin/${admin}/${id}`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            ).then((response) => {
                toast.success(`Admin status updated.`);
            }).catch((err) => {
                if (err.message !== 'canceled') {
                    toast.error(err.response.data);
                }
            });
        });
    }

    function updateDashboards(id, current, value) {
        var user_dashboards = [];
        var f = false;
        current.forEach((db) => {
            user_dashboards.push(db._id);
            if (db._id === value) {
                f = true;
            }
        });
        if (!f) {
            user_dashboards.push(value);
        } else {
            user_dashboards = user_dashboards.filter((x) => {
                return x !== value;
            });
        }
        // no dashboards = a "Maps only" user: the portal sends them straight to /map
        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.post(
                `${process.env.REACT_APP_BASEURL}/api/users/update/dashboards/${id}`,
                { dashboards: user_dashboards },
                { headers: { Authorization: `Bearer ${token}` } }
            ).then((response) => {
                toast.success('Dashboards updated.');
            }).catch((error) => {
                toast.error(error.response.data);
            });
        }).catch((token_error) => {
            console.log(token_error);
        });
    }

    function updateDistricts(id, current, value) {
        var user_districts = [];
        var f = false;
        current.forEach((db) => {
            user_districts.push(db._id);
            if (db._id === value) {
                f = true;
            }
        });
        if (!f) {
            user_districts.push(value);
        } else {
            user_districts = user_districts.filter((x) => {
                return x !== value;
            });
        }

        if (value === 'All Districts') {
            user_districts = [];
        }
        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.post(
                `${process.env.REACT_APP_BASEURL}/api/users/update/districts/${id}`,
                { districts: user_districts },
                { headers: { Authorization: `Bearer ${token}` } }
            ).then((response) => {
                toast.success('Districts updated.');
            }).catch((error) => {
                toast.error(error.response.data);
            });
        }).catch((token_error) => {
            console.log(token_error);
        });
    }

    function updateWarehouses(id, current, value) {
        var user_warehouses = [];
        var f = false;
        current.forEach((db) => {
            user_warehouses.push(db._id);
            if (db._id === value) {
                f = true;
            }
        });
        if (!f) {
            user_warehouses.push(value);
        } else {
            user_warehouses = user_warehouses.filter((x) => {
                return x !== value;
            });
        }

        if (value === 'All Warehouses') {
            user_warehouses = [];
        }
        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.post(
                `${process.env.REACT_APP_BASEURL}/api/users/update/warehouses/${id}`,
                { warehouses: user_warehouses },
                { headers: { Authorization: `Bearer ${token}` } }
            ).then((response) => {
                toast.success('Warehouses updated.');
            }).catch((error) => {
                toast.error(error.response.data);
            });
        }).catch((token_error) => {
            console.log(token_error);
        });
    }

    function updateSalesmen(id, current, value) {
        var user_salesmen = [];
        var f = false;
        current.forEach((db) => {
            user_salesmen.push(db._id);
            if (db._id === value) {
                f = true;
            }
        });
        if (!f) {
            user_salesmen.push(value);
        } else {
            user_salesmen = user_salesmen.filter((x) => {
                return x !== value;
            });
        }

        if (value === 'All Salesmen') {
            user_salesmen = [];
        }
        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.post(
                `${process.env.REACT_APP_BASEURL}/api/users/update/salesmen/${id}`,
                { salesmen: user_salesmen },
                { headers: { Authorization: `Bearer ${token}` } }
            ).then((response) => {
                toast.success('Salesmen updated.');
            }).catch((error) => {
                toast.error(error.response.data);
            });
        }).catch((token_error) => {
            console.log(token_error);
        });
    }

    function getUsers() {
        const seq = ++usersSeq.current;
        getAccessTokenSilently({
            audience: process.env.REACT_APP_AUTH0AUDIENCE,
            scope: process.env.REACT_APP_AUTH0SCOPE
        }).then((token) => {
            api.get(`${process.env.REACT_APP_BASEURL}/api/users/all`,
                {
                    headers: { Authorization: `Bearer ${token}` }
                }
            ).then((response) => {
                if (seq !== usersSeq.current) return;   // a newer request superseded this one
                var r = [];
                response.data.forEach((row) => {
                    r.push({
                        id: row._id,
                        col0: row.fname,
                        col1: row.lname,
                        col2: row.email,
                        col3: row.admin,
                        col4: row.dashboards,
                        col5: row.auth0,
                        districts: row.districts,
                        warehouses: row.warehouses,
                        salesmen: row.salesmen
                    });
                });
                setRows(r);
            }).catch((err) => {
                if (err.message !== 'canceled') {
                    console.log(err);
                }
            });
        });
    }

    // The grid opens only once ALL four lookup lists have loaded. With a list missing, every user's
    // cell for it would read "All ..." and clicking that would save [] — wiping real assignments,
    // which are also the map's row-level security. On failure, show an error with a retry instead.
    function loadLookups() {
        setLookupsError(false);
        return Promise.all([getDashboards(), getDistricts(), getWarehouses(), getSalesmen()]).then((ok) => {
            if (ok.every(Boolean)) setLookupsReady(true);
            else setLookupsError(true);
        });
    }

    // Columns are derived from the CURRENT lookup lists. They used to be built inside getUsers from
    // whatever lists had loaded when that request started, so a slower, older response could leave
    // the Salesmen/Warehouses menus with only "All" (ISS-17). Memoized so the grid keeps column
    // state (hidden columns, widths) across unrelated re-renders.
    const columns = useMemo(() => [
        { field: 'col0', headerName: 'First Name', flex: .25, minWidth: 100, type: 'string' },
        { field: 'col1', headerName: 'Last Name', flex: .25, minWidth: 100, type: 'string' },
        { field: 'col2', headerName: 'Email', flex: .25, minWidth: 100, type: 'string' },
        {
            field: 'col3', headerName: 'Admin', flex: .25, minWidth: 100,
            renderCell: (params) => {
                return (
                    <>
                        {
                            user._id === params.row.id
                                ?
                                <Switch
                                    checked={params.value}
                                    color='success'
                                    disabled
                                />
                                :
                                <Switch
                                    checked={params.value}
                                    color='success'
                                    onClick={() => {
                                        toggleAdmin(params.row.id, !params.value);
                                    }}
                                />
                        }
                    </>
                );
            }
        },
        {
            field: 'col4', headerName: 'Dashboards', flex: .75, minWidth: 120, display: 'flex',
            valueGetter: (params) => {
                var user_dashboards = [];
                dashboards.forEach((db) => {
                    params.forEach((ud) => {
                        if (ud._id === db.key) {
                            user_dashboards.push(db.text);
                        }
                    });
                });
                return user_dashboards.length > 0 ? user_dashboards.toString() : MAPS_ONLY;
            },
            renderCell: (params) => {
                var user_dashboards = [];
                dashboards.forEach((db) => {
                    params.row.col4.forEach((ud) => {
                        if (ud._id === db.key) {
                            user_dashboards.push(db.text);
                        }
                    });
                });

                return (
                    <FormControl sx={{ minWidth: 120, maxWidth: '95%' }} size="small">
                        <Select
                            labelId="user-dash-select-label"
                            id="user-dash-select"
                            multiple
                            autoWidth
                            value={user_dashboards}
                            onChange={(e, data) => { updateDashboards(params.row.id, params.row.col4, data.props.value) }}
                            input={<OutlinedInput />}
                            displayEmpty
                            renderValue={(selected) => selected.length > 0 ? selected.join(', ') : MAPS_ONLY}
                            MenuProps={MenuProps}
                        >
                            {dashboards.map((db) => (
                                <MenuItem key={db.key} value={db.value}>
                                    <Checkbox checked={user_dashboards.indexOf(db.text) > -1} />
                                    <ListItemText primary={db.text} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                );
            }
        },
        {
            field: 'districts', headerName: 'Districts', flex: .75, minWidth: 120, display: 'flex',
            valueGetter: (params) => {
                var user_districts = [];
                districts.forEach((db) => {
                    params.forEach((ud) => {
                        if (ud._id === db.key) {
                            user_districts.push(db.text);
                        }
                    });
                });
                return user_districts.length > 0 ? user_districts.toString() : "All Districts";
            },
            renderCell: (params) => {
                var user_districts = [];
                districts.forEach((db) => {
                    params.row.districts.forEach((ud) => {
                        if (ud._id === db.key) {
                            user_districts.push(db.text);
                        }
                    });
                });

                const handleChange = (event, data) => {
                    const value = data.props.value;
                    updateDistricts(params.row.id, params.row.districts, value);
                };

                return (
                    <FormControl sx={{ minWidth: 120, maxWidth: '95%' }} size="small">
                        <Select
                            labelId="user-district-select-label"
                            id="user-district-select"
                            multiple
                            autoWidth
                            value={user_districts.length > 0 ? user_districts : ["All Districts"]}
                            onChange={handleChange}
                            input={<OutlinedInput />}
                            renderValue={(selected) => selected.join(', ')}
                            MenuProps={MenuProps}
                        >
                            <MenuItem key="all-districts" value="All Districts">
                                <Checkbox checked={user_districts.length === 0} />
                                <ListItemText primary="All Districts" />
                            </MenuItem>
                            {districts.map((db) => (
                                <MenuItem key={db.key} value={db.value}>
                                    <Checkbox checked={user_districts.indexOf(db.text) > -1} />
                                    <ListItemText primary={db.text} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                );
            }
        },
        {
            field: 'warehouses', headerName: 'Warehouses', flex: .75, minWidth: 120, display: 'flex',
            valueGetter: (params) => {
                var user_warehouses = [];
                warehouses.forEach((db) => {
                    params.forEach((ud) => {
                        if (ud._id === db.key) {
                            user_warehouses.push(db.text);
                        }
                    });
                });
                return user_warehouses.length > 0 ? user_warehouses.toString() : "All Warehouses";
            },
            renderCell: (params) => {
                var user_warehouses = [];
                warehouses.forEach((db) => {
                    params.row.warehouses.forEach((ud) => {
                        if (ud._id === db.key) {
                            user_warehouses.push(db.text);
                        }
                    });
                });

                const handleChange = (event, data) => {
                    const value = data.props.value;
                    updateWarehouses(params.row.id, params.row.warehouses, value);
                };

                return (
                    <FormControl sx={{ minWidth: 120, maxWidth: '95%' }} size="small">
                        <Select
                            labelId="user-warehouse-select-label"
                            id="user-warehouse-select"
                            multiple
                            autoWidth
                            value={user_warehouses.length > 0 ? user_warehouses : ["All Warehouses"]}
                            onChange={handleChange}
                            input={<OutlinedInput />}
                            renderValue={(selected) => selected.join(', ')}
                            MenuProps={MenuProps}
                        >
                            <MenuItem key="all-warehouses" value="All Warehouses">
                                <Checkbox checked={user_warehouses.length === 0} />
                                <ListItemText primary="All Warehouses" />
                            </MenuItem>
                            {warehouses.map((db) => (
                                <MenuItem key={db.key} value={db.value}>
                                    <Checkbox checked={user_warehouses.indexOf(db.text) > -1} />
                                    <ListItemText primary={db.text} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                );
            }
        },
        {
            field: 'salesmen', headerName: 'Salesmen', flex: .75, minWidth: 120, display: 'flex',
            valueGetter: (params) => {
                var user_salesmen = [];
                salesmen.forEach((db) => {
                    params.forEach((ud) => {
                        if (ud._id === db.key) {
                            user_salesmen.push(db.text);
                        }
                    });
                });
                return user_salesmen.length > 0 ? user_salesmen.toString() : "All Salesmen";
            },
            renderCell: (params) => {
                var user_salesmen = [];
                salesmen.forEach((db) => {
                    params.row.salesmen.forEach((ud) => {
                        if (ud._id === db.key) {
                            user_salesmen.push(db.text);
                        }
                    });
                });

                const handleChange = (event, data) => {
                    const value = data.props.value;
                    updateSalesmen(params.row.id, params.row.salesmen, value);
                };

                return (
                    <FormControl sx={{ minWidth: 120, maxWidth: '95%' }} size="small">
                        <Select
                            labelId="user-salesmen-select-label"
                            id="user-salesmen-select"
                            multiple
                            autoWidth
                            value={user_salesmen.length > 0 ? user_salesmen : ["All Salesmen"]}
                            onChange={handleChange}
                            input={<OutlinedInput />}
                            renderValue={(selected) => selected.join(', ')}
                            MenuProps={MenuProps}
                        >
                            <MenuItem key="all-salesmen" value="All Salesmen">
                                <Checkbox checked={user_salesmen.length === 0} />
                                <ListItemText primary="All Salesmen" />
                            </MenuItem>
                            {salesmen.map((db) => (
                                <MenuItem key={db.key} value={db.value}>
                                    <Checkbox checked={user_salesmen.indexOf(db.text) > -1} />
                                    <ListItemText primary={db.text} />
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                );
            }
        },
        {
            field: 'col5', headerName: 'Delete', flex: .25, minWidth: 130,
            renderCell: (params) => {
                return (
                    <>
                        {
                            user._id === params.row.id
                                ?
                                <Button variant='contained' color='error' disabled size='small'>Delete User</Button>
                                :
                                <Button variant='contained' color='error' size='small' onClick={() => {
                                    setDeleteId(params.row.id);
                                    setDeleteAuth(params.value);
                                    handleDeleteClickOpen();
                                }}>Delete User</Button>
                        }
                    </>
                );
            }
        },
    ], [dashboards, districts, warehouses, salesmen, user && user._id]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        loadLookups();
        socket.on('dashboards', getDashboards);
        socket.on('districts', getDistricts);
        socket.on('warehouses', getWarehouses);
        socket.on('salesmen', getSalesmen);

        return () => {
            socket.off('dashboards', getDashboards);
            socket.off('districts', getDistricts);
            socket.off('warehouses', getWarehouses);
            socket.off('salesmen', getSalesmen);
        };
    }, []);

    useEffect(() => {
        if (isConnected) {
            getUsers();
            socket.on('users', getUsers);
            // after a RE-connect, refetch the lists too: change events sent while the socket was down
            // are never replayed (the first load is handled by loadLookups on mount)
            if (lookupsReady) { getDashboards(); getDistricts(); getWarehouses(); getSalesmen(); }
        }

        return () => {
            socket.off('users', getUsers);
        };
    }, [isConnected]); // eslint-disable-line react-hooks/exhaustive-deps

    if (user.admin) {
        if (lookupsError && !lookupsReady) {
            return (
                <Box
                    component="main"
                    sx={{ flexGrow: 1, p: 3, alignItems: 'center', textAlign: 'center' }}
                >
                    <WarningRoundedIcon size={60} thickness={4} />
                    <p>Couldn't load the dashboard, district, warehouse and salesman lists.</p>
                    <Button variant='contained' onClick={loadLookups}>Retry</Button>
                </Box>
            );
        } else if (rows !== null && lookupsReady) {
            return (
                <>
                    <Backdrop
                        sx={{ color: '#fff', zIndex: 10000000 }}
                        open={false}
                    >
                        <CircularProgress color="inherit" />
                    </Backdrop>
                    <Dialog
                        open={openAdd}
                        onClose={handleAddClose}
                        fullWidth
                        maxWidth="sm"
                    >
                        <DialogContent>
                            <List>
                                <ListItem>
                                    <TextField variant="standard" label='Email' onChange={(event) => { setAddEmail(event.target.value) }} sx={{ width: '100%' }} />
                                </ListItem>
                                <ListItem>
                                    <TextField variant="standard" label='First Name' onChange={(event) => { setAddFname(event.target.value) }} sx={{ width: '100%' }} />
                                </ListItem>
                                <ListItem>
                                    <TextField variant="standard" label='Last Name' onChange={(event) => { setAddLname(event.target.value) }} sx={{ width: '100%' }} />
                                </ListItem>
                                <ListItem />
                                <ListItem>
                                    <FormControl sx={{ width: '100%' }} size="small">
                                        <InputLabel id="user-dash-select-label" shrink>Dashboards</InputLabel>
                                        <Select
                                            labelId="user-dash-select-label"
                                            id="user-dash-select"
                                            multiple
                                            autoWidth
                                            value={adddashtext}
                                            onChange={(e, data) => { updateAddDashboards(data.props.value) }}
                                            input={<OutlinedInput notched label='Dashboards' />}
                                            displayEmpty
                                            renderValue={(selected) => selected.length > 0 ? selected.join(', ') : `${MAPS_ONLY} (no dashboards)`}
                                            MenuProps={MenuProps}
                                        >
                                            {dashboards.map((db) => (
                                                <MenuItem key={db.key} value={db.value}>
                                                    <Checkbox checked={adddashboards.indexOf(db.value) > -1} />
                                                    <ListItemText primary={db.text} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </ListItem>
                                <ListItem>
                                    <FormControl sx={{ width: '100%' }} size="small">
                                        <InputLabel id="user-district-select-label">Districts</InputLabel>
                                        <Select
                                            labelId="user-district-select-label"
                                            id="user-district-select"
                                            multiple
                                            autoWidth
                                            value={adddistrictstext.length > 0 ? adddistrictstext : ["All Districts"]}
                                            onChange={(e, data) => { updateAddDistricts(data.props.value) }}
                                            input={<OutlinedInput label='Districts' />}
                                            renderValue={(selected) => selected.join(', ')}
                                            MenuProps={MenuProps}
                                        >
                                            <MenuItem key="all-districts" value="All Districts">
                                                <Checkbox checked={adddistricts.length === 0} />
                                                <ListItemText primary="All Districts" />
                                            </MenuItem>
                                            {districts.map((db) => (
                                                <MenuItem key={db.key} value={db.value}>
                                                    <Checkbox checked={adddistricts.indexOf(db.value) > -1} />
                                                    <ListItemText primary={db.text} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </ListItem>
                                <ListItem>
                                    <FormControl sx={{ width: '100%' }} size="small">
                                        <InputLabel id="user-warehouse-select-label">Warehouses</InputLabel>
                                        <Select
                                            labelId="user-warehouse-select-label"
                                            id="user-warehouse-select"
                                            multiple
                                            autoWidth
                                            value={addwarehousestext.length > 0 ? addwarehousestext : ["All Warehouses"]}
                                            onChange={(e, data) => { updateAddWarehouses(data.props.value) }}
                                            input={<OutlinedInput label='Warehouses' />}
                                            renderValue={(selected) => selected.join(', ')}
                                            MenuProps={MenuProps}
                                        >
                                            <MenuItem key="all-warehouses" value="All Warehouses">
                                                <Checkbox checked={addwarehouses.length === 0} />
                                                <ListItemText primary="All Warehouses" />
                                            </MenuItem>
                                            {warehouses.map((db) => (
                                                <MenuItem key={db.key} value={db.value}>
                                                    <Checkbox checked={addwarehouses.indexOf(db.value) > -1} />
                                                    <ListItemText primary={db.text} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </ListItem>
                                <ListItem>
                                    <FormControl sx={{ width: '100%' }} size="small">
                                        <InputLabel id="user-salesmen-select-label">Salesmen</InputLabel>
                                        <Select
                                            labelId="user-salesmen-select-label"
                                            id="user-salesmen-select"
                                            multiple
                                            autoWidth
                                            value={addsalesmentext.length > 0 ? addsalesmentext : ["All Salesmen"]}
                                            onChange={(e, data) => { updateAddSalesmen(data.props.value) }}
                                            input={<OutlinedInput label='Salesmen' />}
                                            renderValue={(selected) => selected.join(', ')}
                                            MenuProps={MenuProps}
                                        >
                                            <MenuItem key="all-salesmen" value="All Salesmen">
                                                <Checkbox checked={addsalesmen.length === 0} />
                                                <ListItemText primary="All Salesmen" />
                                            </MenuItem>
                                            {salesmen.map((db) => (
                                                <MenuItem key={db.key} value={db.value}>
                                                    <Checkbox checked={addsalesmen.indexOf(db.value) > -1} />
                                                    <ListItemText primary={db.text} />
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </ListItem>
                                <ListItem>
                                    <Typography variant='subtitle2'>Admin?</Typography>
                                    <Switch
                                        checked={addAdmin}
                                        color='success'
                                        onClick={() => {
                                            setAddAdmin(!addAdmin);
                                        }}
                                        sx={{ marginRight: '5px' }}
                                    />
                                </ListItem>
                            </List>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleAddClose}>Cancel</Button>
                            <Button onClick={() => { addNewUser(); }}>Add User</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={openDelete}
                        onClose={handleDeleteClose}
                    >
                        <DialogContent>
                            <DialogContentText>Are you sure you want to delete this user account?</DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleDeleteClose} autoFocus>Cancel</Button>
                            <Button color="error" onClick={() => { deleteUser(deleteId, deleteAuth); }}>Delete User Account</Button>
                        </DialogActions>
                    </Dialog>
                    <Box flexGrow={1} sx={{ padding: '20px' }}>
                        <Button onClick={handleAddClickOpen}>Add New User</Button>
                        <div style={{ height: '80vh', width: '100%' }}>
                            <DataGridPro
                                slots={{
                                    toolbar: GridToolbar
                                }}
                                slotProps={{
                                    toolbar: {
                                        showQuickFilter: true,
                                        quickFilterProps: { debounceMs: 500 }
                                    }
                                }}
                                rows={rows}
                                columns={columns}
                                pagination
                                disableRowSelectionOnClick
                            />
                        </div>
                    </Box>
                </>
            );
        } else {
            return (
                <Box
                    component="main"
                    sx={{ flexGrow: 1, p: 3, alignItems: 'center', textAlign: 'center' }}
                >
                    <CircularProgress size={60} thickness={4} />
                </Box>
            );
        }
    } else {
        return (
            <Box
                component="main"
                sx={{ flexGrow: 1, p: 3, alignItems: 'center', textAlign: 'center' }}
            >
                <WarningRoundedIcon size={60} thickness={4} />
                <p>Not Authorized</p>
            </Box>
        );
    }
}

export default Users;